import { Link } from "react-router-dom"
import "./ContraceptionPage.css"

const services = [
  { name: "Oral Contraceptives", description: "Combined and progesterone-only pills with ongoing supply" },
  { name: "Emergency Contraception", description: "Morning after pill available without prescription" },
  { name: "Repeat Prescriptions", description: "Convenient ongoing supply of your regular contraception" },
]

const faqs = [
  {
    question: "What contraception services do you offer?",
    answer: "We offer a range of contraception services including emergency contraception (morning after pill), ongoing supply of oral contraceptives, and confidential advice on your contraception options."
  },
  {
    question: "Do I need an appointment?",
    answer: "For emergency contraception, you can walk in without an appointment. For routine contraception consultations and ongoing supplies, we recommend booking an appointment to ensure dedicated time with our pharmacist."
  },
  {
    question: "Is the service confidential?",
    answer: "Absolutely. All consultations are completely confidential. We have a private consultation room where you can discuss your needs in complete privacy."
  },
  {
    question: "Can I get the morning after pill here?",
    answer: "Yes, we can supply emergency hormonal contraception (the morning after pill) without a prescription. Our pharmacist will have a short confidential consultation with you to ensure it's suitable."
  },
  {
    question: "How much does it cost?",
    answer: "Many contraception services are available free on the NHS. For private services or if you're not eligible for NHS supply, our pharmacist will explain the costs during your consultation."
  },
]

function ContraceptionPage() {
  return (
    <div className="contraception-page">
      <section className="ct-hero">
        <h1>Contraception</h1>
        <p className="ct-tagline">
          Confidential contraception advice and services
        </p>
      </section>

      <section className="ct-intro">
        <p>
          Our pharmacy offers confidential contraception services in a private and supportive
          environment. Our trained pharmacists can help you find the right contraception for your needs.
        </p>
        <p>
          Whether you need emergency contraception, want to discuss your options, or need ongoing
          supply of your regular contraception, we're here to help.
        </p>
        <p className="ct-highlight">
          Private consultations available - your health, your choice.
        </p>
      </section>

      <section className="ct-services">
        <h2>Our Contraception Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                </svg>
              </div>
              <h3>{service.name}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="ct-cta">
        <h2>Ready to Get Started?</h2>
        <p>
          Book a confidential consultation with our pharmacist to discuss your contraception
          needs in a private and supportive environment.
        </p>
        <Link to="/services?service=contraception" className="button primary">
          Book a Consultation
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </Link>
      </section>

      <section className="ct-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default ContraceptionPage
